<template>
  <div class="account">
    <drag-modal :visible="visible" @cancel="rest" :title="title" width="584px">
      <a-form-model ref="newforms" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="权限组名称" prop="title">
          <a-input v-model="form.title" :disabled="type == 0" />
        </a-form-model-item>
        <a-form-model-item label="权限组说明" prop="remark">
          <a-input v-model="form.remark" :disabled="type == 0" />
        </a-form-model-item>
        <a-form-model-item label="权限" prop="menu_ids">
          <a-tree-select :getPopupContainer="triggerNode => triggerNode.parentNode" :maxTagCount='1'
            :maxTagTextLength='5' v-model="form.menu_ids" style="width: 100%" :tree-data="treeData" tree-checkable
            :showCheckedStrategy="SHOW_ALL"
            :replace-fields="{ children: 'child', title: 'title', key: 'id', value: 'id' }" allow-clear
            :disabled="type == 0" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-switch checked-children="启用" un-checked-children="禁用" v-model="form.status" default-checked
            :disabled="type == 0" />
        </a-form-model-item>
        <a-form-model-item style="text-align:center;" v-if='type != 0' :wrapper-col="{ span: 19 }">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="width:148px;color: #fff;">保存</a-button>
          </a-popconfirm>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
    <div class="top wbg">
      <a-row class="row">
        <a-button icon="plus" @click="type = 1; visible = true">新增</a-button>
      </a-row>
    </div>
    <div class="tcon wbg">
      <div class="tableList">
        <table class="table" style="table-layout: fixed;">
          <thead class="thead">
            <td width='50'>序号</td>
            <td width='180'>权限组名称</td>
            <td width='220'>添加时间</td>
            <td width='220'>修改时间</td>
            <td width='304'>权限组说明</td>
            <td width="100">状态</td>
            <td width='140'>操作</td>
          </thead>
          <tbody>
            <tr v-for='(i, index) in list' :key='i.id'>
              <td>{{ 10 * (page - 1) + index + 1 }}</td>
              <td> {{ i.title }}</td>
              <td>{{ i.create_time }}</td>
              <td> {{ i.update_time }}</td>
              <td>{{ i.remark }}</td>
              <td>
                <font color="#52c41a" v-if='i.status == 1'>启用</font>
                <font color="#f00" v-else>禁用</font>
              </td>
              <td>
                <a href="javascript:void(0);" @click="see(i.id, 0)">查看</a>
                <span class="line"></span>
                <a href="javascript:void(0);" @click="see(i.id, 2)">修改</a>
                <span class="line"></span>
                <a-popconfirm title="确认删除此权限组吗?" ok-text="确定" cancel-text="取消" @confirm="del(i.id)">
                  <a href='javascript:void(0);' class='del'>删除</a>
                </a-popconfirm>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pages" v-if="count > 10">
          <a-pagination v-model="page" show-quick-jumper :total="count" show-less-items :pageSize='10'
            @change='getList' />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { accuserRole } from '@/server/user'
import { list } from '@/power/api'
import { TreeSelect } from 'ant-design-vue';
export default {
  data() {
    return {
      list: [],
      count: 0,
      form: {
        menu_ids: [],
        status: true
      },
      type: 0,   //0 查看 1 新增 2修改
      page: 1,
      visible: false,
      treeData: [],
      SHOW_ALL: TreeSelect.SHOW_ALL,
      rules: {
        title: { required: true, message: '请输入权限组名称', trigger: 'blur' },
        uname: { required: false },
        menu_ids: { required: true, message: '请设置权限', trigger: 'blur', }
      }
    }
  },
  components: { TreeSelect },
  computed: {
    title() {
      return ['查看', '新增', '修改'][this.type]
    }
  },
  created() {
    this.getList()
    list({ belong: 2, status: 1 }).then(e => {
      this.treeData = e
    })
  },

  methods: {
    see(id, type) {
      this.type = type
      accuserRole('info', { id: id }).then(e => {
        const { menu_ids, title, remark, status, id } = e.info
        //  const ids=menu.map(ele=>{return ele.menu_id})
        this.form = {
          id: id,
          menu_ids: menu_ids,
          title: title,
          remark: remark,
          status: status === 1
        }
        this.visible = true;
      })
    },
    del(id) {
      accuserRole('delete', { id: id }).then(e => {
        this.$message.success('删除成功')
        this.page = 1
        this.getList()
      })
    },
    getList() {
      accuserRole('index', { page: this.page, limit: 10 }).then(e => {
        this.count = e.count;
        this.list = e.list
      })
    },
    rest() {
      this.$refs.newforms.resetFields()
      this.form.menu_ids = []
      this.form.title = ''
      this.visible = false;
    },
    confirm() {
      let form = JSON.parse(JSON.stringify(this.form))
      if (this.type == 1) delete form.id
      form.status = form.status ? 1 : 0
      accuserRole(this.type == 1 ? 'add' : 'edit', form).then(e => {
        this.$message.success(this.type == 1 ? '新增成功' : '修改成功')
        this.rest()
        this.page = 1
        this.getList()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.col {
  display: flex;
  align-items: center;

  label {
    white-space: nowrap;
  }
}

.account {
  .top {
    padding: 20px;

    .group {
      display: flex;
      align-items: center;
    }

    .to {
      display: inline-block;
      width: 20px;
      height: 1px;
      margin: 0 10px;
      background-color: #dbdcde;
      vertical-align: middle;
    }

    form {
      width: 100%;
    }

    .label {
      display: inline-block;
      margin-right: 60px;
      font-size: 0.875rem;
      color: #0e2949;
    }

    .btns {
      float: right;

      button {
        margin-left: 20px;
        min-width: 90px;
      }
    }
  }
}

.ant-btn {
  // border-color: #1d8bfe;
  // color: #1d8bfe;
}

// .ant-btn-primary {
//   color: #ffffff;
//   border-color: #1d8bfe;
//   background-color: #1d8bfe;
// }
.tcon {
  padding: 0 20px;
  min-height: 760px;

  .tableList {
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p,
          .p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }
}

.modal-footer {
  text-align: center;

  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}

.pages {
  text-align: right;
}
</style>
